
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, MaxLengthValidator, } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { XepLoaiHocKyNamHocService } from 'src/app/Utils/services/xep-loai-hoc-ky-nam-hoc.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatValidator } from '@angular-devkit/schematics/src/formats/format-validator';
import { forEach } from '@angular-devkit/schematics';
import { timeout } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
import { ExportService } from 'src/app/utils/services/export.service';
export function removeSpaces(control: AbstractControl) {
  if (control && control.value && !control.value.replace(/\s/g, '').length) {
    control.setValue('');
  }
  return null;
}
@Component({
  selector: 'app-xep-loai-hoc-ky-nam-hoc',
  templateUrl: './xep-loai-hoc-ky-nam-hoc.component.html',
  styleUrls: ['./xep-loai-hoc-ky-nam-hoc.component.scss']
})
export class XepLoaiHocKyNamHocComponent implements OnInit {
  arrayOne(n: number): any[] {
    return Array(n);
  }
  HighlightRow : Number;  
  Employee : any;  
  ClickedRow:any; 
  public com: common
  Token: any
  dataHeader: any = []
  dataTable: any = []
  dataHeaderSV: any = []
  dataTableSV: any = []
  Nam_hoc_arr: any = []
  dataHe: any = []
  dataKhoa: any = []
  dataKhoaHoc: any = []
  dataKhoaHoc2: any = []
  dataChuyenNganh: any = []
  dataChuyenNganh2: any = []
  dataLop: any = []
  dataLop2: any = []
  dataChart: any = []
  listID_lop: string
  chart: any
  closeResult: string;
  isDisplay: any = true
  ID_dt: any;
  ID_sv: any;
  Ten_sv: any
  Ma_sv: any
  recordTotal:any = 0
  lblTBCHT4: any
  lblTBCHT10: any
  lblTBC_tich_luy: any
  lblXep_loai_hoc_tap10: any
  lblXep_loai_hoc_tap4: any
  lblSo_mon_hoc_lai: any
  lblSo_mon_thi_lai: any
  lblSo_tin_chi_tich_luy: any
  lblXep_hang_hoc_luc: any
  filter = new FormGroup({
    Hoc_ky: new FormControl(1),
    Loai_thong_ke: new FormControl(0),
    Thang_diem: new FormControl(0),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1)+ '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
    Hien_thi: new FormControl(0),
    Nhom: new FormControl(0),
    Lan_thi: new FormControl(0),
    Hien_thi_ten_hoc_phan: new FormControl(true),
    Ghi_chu_diem: new FormControl(false),
    Hien_thi_HP: new FormControl(false),
  });
  constructor(
    private modalService: NgbModal,
    private XepLoaiHocKyNamHocService: XepLoaiHocKyNamHocService,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public exportService: ExportService,
  ) {
    this.ClickedRow = function(index){  
      this.HighlightRow = index;  
    }
   }

  ngOnInit(): void {
  
    
    let element, name, arr
    element = document.getElementById('menu1')
    arr = element.className.split(' ')
    name = 'menu-open'
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name
    }
    var yearNow = new Date().getFullYear() + 4;
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.Token = a.Token

    this.getList()
    
  }
  getList() {
    this.spinner.show()
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z
      IDhe = z[0].ID_he
      this.filter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data
          this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh = z
            this.dataChuyenNganh2 = this.dataChuyenNganh
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop = z
            this.dataLop2 = this.dataLop.filter(i => i.ID_he == IDhe);
          });
          this.spinner.hide()
        });
      });
    });
  }
  changeHe() {
    this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
  }
  changeKhoa() {
    if (this.filter.value.ID_khoa != "") {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
    }
  }
  changeKhoaHoc() {
    if (this.filter.value.Khoa_hoc != "") {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
    } else {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
    }

  }
  changeChuyenNganh() {
    if (this.filter.value.ID_chuyen_nganh != "") {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
      this.dataLop2 = this.dataLop2.filter(i => i.ID_chuyen_nganh == this.filter.value.ID_chuyen_nganh);
    } else {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
    }
  }
  getData() {    
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
      this.listID_lop += "0"
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    
    this.spinner.show();
    this.dataHeader = []
    this.dataTable = []    
    
      let req = {
        "Loai_thong_ke": this.filter.value.Loai_thong_ke,
        "Thang_diem": this.filter.value.Hien_thi,
        "Lan_thi": this.filter.value.Lan_thi,
        "Nam_hoc": this.filter.value.Nam_hoc,
        "Ghi_chu_diem": this.filter.value.Ghi_chu_diem,
        "Hien_thi_diem_hp_khong_tinh_tbc": this.filter.value.Hien_thi_HP,
        "Hoc_ky": this.filter.value.Hoc_ky,
        "objLop": {
          "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
          "Ten_lop": "",
          "ID_he": this.filter.value.ID_he,
          "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
          "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
          "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,          
          "Ten_he": "",
          "Ten_khoa": "",
          "Chuyen_nganh": "",
          "Ten_nganh": "",
          "Nien_khoa": "2014-2018",
          "ID_dt": 0,
          "So_sv": 0,
          "Ra_truong": false,
          "ID_nganh": 0,
          "dsID_lop": this.listID_lop,
          "dsID_dt": "0"
        },
        "Nhom_thong_ke": this.filter.value.Nhom,
        "ID_he": this.filter.value.ID_he,
        "UserName": a.Info.UserName
      }

      this.XepLoaiHocKyNamHocService.getList(req, this.Token).subscribe((z) => {
        this.spinner.hide();
        if(z.Status==1){
          this.dataHeader = z.Header
          this.dataTable = z.Data
          this.recordTotal = z.recordTotal
        }else{
          this.toastr.error(z.Message)
        }
      });
    
  }
  Excel()
  {
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
      this.listID_lop += "0"
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    
    this.spinner.show();  
      let req = {
        "Loai_thong_ke": this.filter.value.Loai_thong_ke,
        "Thang_diem": this.filter.value.Hien_thi,
        "Lan_thi": this.filter.value.Lan_thi,
        "Nam_hoc": this.filter.value.Nam_hoc,
        "Ghi_chu_diem": this.filter.value.Ghi_chu_diem,
        "Hien_thi_diem_hp_khong_tinh_tbc": this.filter.value.Hien_thi_HP,
        "Hoc_ky": this.filter.value.Hoc_ky,
        "objLop": {
          "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
          "Ten_lop": "",
          "ID_he": this.filter.value.ID_he,
          "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
          "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
          "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,          
          "Ten_he": "",
          "Ten_khoa": "",
          "Chuyen_nganh": "",
          "Ten_nganh": "",
          "Nien_khoa": "2014-2018",
          "ID_dt": 0,
          "So_sv": 0,
          "Ra_truong": false,
          "ID_nganh": 0,
          "dsID_lop": this.listID_lop,
          "dsID_dt": "0"
        },
        "Nhom_thong_ke": this.filter.value.Nhom,
        "ID_he": this.filter.value.ID_he,
        "UserName": a.Info.UserName,
        "User_ID":a.Info.UserID,
      }

      var r = confirm("File của bạn sẽ được tải xuống trong giây lát!");
    if (r) {
     
      this.spinner.show();            
      this.XepLoaiHocKyNamHocService.Excel(req,a.Token)
        .subscribe(z => {
          if (z.Status == 1) {
            this.exportService.exportExcelByte(z.FileData, 'ThongKeDiemHocPhan');
            this.toastr.success("File đã được tải xuống", "Tác vụ thành công")
            this.spinner.hide();
          }
          else {
            this.toastr.error(z.Message, "Tác vụ thất bại")
            this.spinner.hide();
          }
        });
    };
  }

  ExcelXepLoai()
  {
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
      this.listID_lop += "0"
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    
    this.spinner.show();
    this.dataHeader = []
    this.dataTable = []    
    let req = {
      "Thang_diem": this.filter.value.Thang_diem,
      "Lan_thi": this.filter.value.Lan_thi,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "Ghi_chu_diem": this.filter.value.Ghi_chu_diem,
      "ID_lop_list": this.listID_lop,
      "ID_he": this.filter.value.ID_he,
      "UserName": a.Info.UserName,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "objLop": {
        "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": this.filter.value.ID_he,
        "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
        "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,
        "Hoc_ky": this.filter.value.Hoc_ky,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 0,
        "dsID_lop": this.listID_lop,
        "dsID_dt": "0"
      },

    }
      var r = confirm("File của bạn sẽ được tải xuống trong giây lát!");
    if (r) {
     
      this.spinner.show();            
      this.XepLoaiHocKyNamHocService.ExcelXeploai(req,a.Token)
        .subscribe(z => {
          if (z.Status == 1) {
            this.exportService.exportExcelByte(z.FileData, 'ThongKeDiemHocPhan');
            this.toastr.success("File đã được tải xuống", "Tác vụ thành công")
            this.spinner.hide();
          }
          else {
            this.toastr.error(z.Message, "Tác vụ thất bại")
            this.spinner.hide();
          }
        });
    };
  }

  changeThongKe()
  {

  }
  submit() {
    if (this.filter.value.Khoa_hoc=="" || this.filter.value.ID_khoa=="")
    {
      this.toastr.warning("Vui lòng chọn đầy khoa, khóa học để thống kê!")
      return false
    }
    //this.isDisplay = true
    this.getData()
  }
  submit_xl() {
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
      this.listID_lop += "0"
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.spinner.show();
    this.dataHeader = []
    this.dataTable = []
    let req = {
      "Thang_diem": this.filter.value.Thang_diem,
      "Lan_thi": this.filter.value.Lan_thi,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "Ghi_chu_diem": this.filter.value.Ghi_chu_diem,
      "ID_lop_list": this.listID_lop,
      "ID_he": this.filter.value.ID_he,
      "UserName": a.Info.UserName,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "objLop": {
        "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": this.filter.value.ID_he,
        "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
        "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,
        "Hoc_ky": this.filter.value.Hoc_ky,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 0,
        "dsID_lop": this.listID_lop,
        "dsID_dt": "0"
      },

    }
    this.XepLoaiHocKyNamHocService.ThongKeXepLoai(req, this.Token).subscribe((z) => {
      this.spinner.hide();
      if(z.Status==1){
        this.dataHeader = z.Header
        this.dataTable = z.Data
      }else{
        this.toastr.error(z.Message)
      }
    });
  }
  SetID_sv(ID_sv, ID_dt, Ma_sv, Ten_sv) {
    this.ID_dt = ID_dt
    this.ID_sv = ID_sv
    this.Ma_sv = Ma_sv
    this.Ten_sv = Ten_sv
  }
  GetDataSV() {
   
    if (this.ID_dt == undefined || this.ID_sv == undefined ) {
      this.toastr.warning("Vui lòng chọn sinh viên cần xem điểm")
      return false
    }
    let req = {
      "Loai_bang_diem": this.filter.value.Loai_thong_ke,
      "Lan_thi": this.filter.value.Lan_thi,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "ID_dt": this.ID_dt,
      "ID_sv": this.ID_sv,
      "ID_he": this.filter.value.ID_he,
    }
    this.spinner.show()
    this.XepLoaiHocKyNamHocService.BangDiemSV(req, this.Token).subscribe((z) => {
      this.spinner.hide();
      if(z.Status==1){
        this.lblTBCHT4 = z.lblTBCHT4
        this.lblTBCHT10 = z.lblTBCHT10
        this.lblTBC_tich_luy = z.lblTBC_tich_luy
        this.lblXep_loai_hoc_tap10 = z.lblXep_loai_hoc_tap10
        this.lblXep_loai_hoc_tap4 = z.lblXep_loai_hoc_tap4
        this.lblSo_mon_hoc_lai = z.lblSo_mon_hoc_lai
        this.lblSo_mon_thi_lai = z.lblSo_mon_thi_lai
        this.lblSo_tin_chi_tich_luy = z.lblSo_tin_chi_tich_luy
        this.lblXep_hang_hoc_luc = z.lblXep_hang_hoc_luc
        this.dataHeaderSV = z.Header
        this.dataTableSV = z.Data        
      }else{
        this.toastr.error(z.Message)
      }
     

    });
  }
  open(content) {
    if (this.ID_dt == undefined || this.ID_sv == undefined ) {
      this.toastr.warning("Vui lòng chọn sinh viên cần xem điểm")
      return false
    }
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
